import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { TerraIconModule } from '@ninety/terra';
import { ButtonComponent } from '@ninety/ui/core';

import { MazActions } from '../../../maz/_state/maz.actions';
import { GuideActions } from '../../_state/guide.actions';
import { PhaseStep } from '../../models/phase-step';

@Component({
  selector: 'ninety-phase-step',
  templateUrl: './phase-step.component.html',
  styleUrls: ['./phase-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TerraIconModule, ButtonComponent],
})
export class PhaseStepComponent {
  private store = inject(Store);

  @Input() step: PhaseStep;
  @Input() mazChatEnabled: boolean;

  openLearnMoreLink(): void {
    this.store.dispatch(GuideActions.openResourceLink({ url: this.step.resource_link }));
  }

  suggestedPromptClick(): void {
    this.store.dispatch(MazActions.sendMessageToMaz({ userInput: this.step.suggested_prompt }));
  }
}
